import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "incidentORIheader mb-3" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "nav nav-tabs" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  id: "activeTab",
  class: "border-end border-bottom border-start p-3"
}
const _hoisted_9 = {
  id: "actions",
  class: "mt-3"
}
const _hoisted_10 = ["href"]

import { ref, computed } from 'vue';
import { Tab } from './TabLayout.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'TabLayout',
  props: {
    headerLeftLabel: {},
    headerRightLabel: {},
    tabs: { default: () => [] },
    modelValue: {},
    cancelButtonUrl: {}
  },
  emits: ["update-tab", "submit", "update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

var cancelUrlWithFallback = "dataupload.aspx?source=0";
if (props.cancelButtonUrl && props.cancelButtonUrl.length > 0) {
    cancelUrlWithFallback = props.cancelButtonUrl;
}

const canGoNext = computed(() => {
    return canGo(+1);
});

const canGoPrevious = computed(() => {
    return canGo(-1);
});

const maxTab = computed(() => {
    return props.tabs.length;
});

const activeTabIndex = computed(() => {
    for (let i = 0; i < props.tabs.length; i++) {
        if (isActive(props.tabs[i].componentName)) {
            return i;
        }
    }

    return -1;
});

function setActiveTab(componentName: String) {
    emit('update-tab', componentName);
}

function isActive(tabName: string): boolean {
    return tabName == props.modelValue;
}

function goToPage(tabIndex: number) {
    if (tabIndex < props.tabs.length) {
        setActiveTab(props.tabs[tabIndex].componentName);
    }
}

function go(deltaPage: number) {
    goToPage(Math.max(0, Math.min(props.maxTab, activeTabIndex + deltaPage)));
}

function canGo(deltaPage: number) {
    var newPage = activeTabIndex + deltaPage + 1;
    return newPage >= 1 && newPage <= maxTab;
}

function handleSubmit() {
    emit("submit");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.headerLeftLabel), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.headerRightLabel), 1)
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link", { 'active': isActive(tab.componentName) }]),
            "aria-current": "true",
            href: "#",
            onClick: _withModifiers(($event: any) => (setActiveTab(tab.componentName)), ["prevent"])
          }, _toDisplayString(tab.displayText), 11, _hoisted_7)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        href: _unref(cancelUrlWithFallback),
        class: "btn btn-secondary"
      }, "Cancel", 8, _hoisted_10),
      (canGoPrevious.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-secondary ms-3",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (go(-1)), ["prevent"]))
          }, " Previous "))
        : _createCommentVNode("", true),
      (canGoNext.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary float-end",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (go(+1)), ["prevent"]))
          }, " Next "))
        : _createCommentVNode("", true),
      (!canGoNext.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btn btn-primary float-end",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSubmit()), ["prevent"]))
          }, " Submit "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})